export default __webpack_public_path__ + "static/media/碳盤查4.d8664a61.png";